import { Lightning } from "@lightningjs/sdk"

export default class GradientBottom extends Lightning.Component {
    static override _template() {
        return {
            w: 1920,
            h: 1250,
            GradientFade: {
                w: 1920,
                h: 50,
                rect: true,
                colorTop: 0x0011113b,
                colorBottom: 0xcc11113b,
            },
            SolidBg: {
                y: 50,
                w: 1920,
                h: 1200,
                rect: true,
                color: 0xcc11113b,
            }
        }
    }
}
